module.exports = __webpack_public_path__ + "img/ail.c52bcc54.png";